
import { mapState, mapStores } from "pinia";
import { defineComponent, PropType } from "vue";
import IndicatorWidget from './widget-indicator.vue';
import WidgetBase, { WidgetMode } from './widget.vue';
import { useRoute } from "vue-router";
import { useDashboardStore } from "~/store/dashboard.store";
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { Station } from "~/api/models/station.model";
import moment from "moment";

const fake: Station = {
    "id": "6284fe2033742b160608063d",
    "name": "aura-0001-0004",
    "group_id": "6087d7a6037e556156137cfc",
    "group_name": "aura-co2",
    "location": {
        "lat": 45.19207209857447,
        "lon": 5.706631153651841
    },
    "type": "aura-co2",
    "status": "online",
    "last_seen": moment().subtract(5, 'minute').unix(),
    "image_url": null,
    "latest_values": { "CO2_alarm": 0, "CO2": 690, "temperature": 22.3, "humidity": 35, "pressure": 984, "mslPressure": 984, "SOC": 91, "CO2_aqi": 31, "aqi": 31 },
    "latest_values_units": { "CO2_alarm": null, "CO2": "ppm", "temperature": "degC", "humidity": "%", "pressure": "hPa", "mslPressure": "hPa", "SOC": "%" },
    "eid": "E11CD47102210014",
    "pairing_token": "E11CD47102210014",
    "latest_raw_values": { "CO2_error": 0, "rssi": -59, "snr": 10.5, "gateways_count": 2, "message_count": 295, "spreading_factor": 7, "battery": 3460 },
    "latest_raw_values_units": { "CO2_error": null, "rssi": "dB", "snr": "dB", "gateways_count": null, "message_count": null, "spreading_factor": null, "battery": "mV" },
    "calibration": { "battery": { "commissioningDate": "2022-06-02T06:44:09+0000" } },
    "metadata": { "AppEUI": "240504D07ED5B371", "AppKey": "32CFCC054AD9D438C8C7E542B6CA4603", "DevEUI": "E11CD47102210014", "FW_version": "nan", "PN": "AURA20LC221EU", "SN": "0221-0014", "elichens/public/color": "rgba(184, 31, 31, 1)", "elichens/public/label": "My Aura station", "elichens/public/locality": "Grenoble", "elichens/public/locality_long": "Grenoble, France", "elichens/public/location": "Meeting Room", "elichens/public/timezone_id": "Asia/Tokyo", "sensor_id": "nan", "stm_id": "nan", "elichens/aura-mobile-app": { "upgrades": [{ "date": "2022-10-18T13:55:34.783Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-18T14:03:58.265Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-18T14:11:34.455Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T08:13:42.540Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking"] }, { "date": "2022-10-26T08:45:11.442Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": false, "steps_done": ["download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T08:55:12.087Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T12:22:20.487Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-26T12:30:00.585Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-28T11:49:22.915Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-10-28T12:12:38.482Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }, { "date": "2022-11-10T15:15:20.834Z", "version": "36c3f", "pn": "AURA20LC221EU", "user": "mathias.billoir-ext@elichens.com", "completed": true, "steps_done": ["init", "download-binaries", "enter_bootloader", "transfert-binaries", "rebooting", "clean", "checking", "configuration"] }] }, "elichens/public/tz_offset": 32400 }
};

export default defineComponent({

    extends: WidgetContentBase,

    components: {
        IndicatorWidget,
    },

    data() {
        const route = useRoute();
        return {
            route: route,
            active: route?.query?.indicator === 'humidity',
        };
    },

    computed: {
        ...mapStores(useDashboardStore),
        ...mapState(useDashboardStore, ['currentStation']),

        station(): Station {
            return this.fake ? fake : this.currentStation;
        },

        humidity(): number {
            return this.station?.latest_values?.humidity || 0;
        },

        unit(): string {
            return '%RH';
        },

        aqi(): number {
            return this.station?.latest_values?.aqi_humidity || -1;
        },

        img(): string {
            return require('@/humidity_mask.png').default
        }
    },

    methods: {
        onWidgetClick(): void {
            if(this.editable) {
                return;
            }
            
            this.$router.replace({ path: this.route ? this.route.path : '', query: { ...this.route.query, indicator: 'humidity' } });
        }
    },

    watch: {
        $route(to, from) {
            this.active = to?.query?.indicator === 'humidity';
        }
    }
})

